import { atom } from 'jotai';

interface ILibraLandingModalState {
  open: boolean;
  hasClosed: boolean;
}

export const $LandingModalState = atom<ILibraLandingModalState>({
  open: false,
  hasClosed: false,
});
